import React from 'react';
import PropTypes from 'prop-types';
import withConfig from 'config/withConfig';

const CitySchema = ({
    city: {
        latitude,
        longitude,
        relative_url: relativeUrl,
        short_description: shortDescription,
        description,
        state,
        city,
    },
    siteUrl,
}) => {
    const url = `${siteUrl}/${relativeUrl}`;

    return (
        <>
            <meta itemProp="url" content={url} />
            <span
                itemProp="geo"
                itemScope
                itemType="http://schema.org/GeoCoordinates"
            >
                <meta itemProp="latitude" content={latitude} />
                <meta itemProp="longitude" content={longitude} />
            </span>
            {description && (
                <span
                    className="hidden"
                    itemProp="description"
                    dangerouslySetInnerHTML={{__html: description}}
                />
            )}
            <span
                itemProp="address"
                itemScope
                itemType="http://schema.org/PostalAddress"
            >
                {city && <meta itemProp="addressLocality" content={city} />}
                {state && <meta itemProp="addressRegion" content={state} />}
            </span>
            <span itemProp="sameAs" itemScope itemType="http://schema.org/City">
                <meta itemProp="name" content={city} />
                <meta itemProp="url" content={url} />
            </span>
        </>
    );
};

CitySchema.propTypes = {
    city: PropTypes.object.isRequired,
    siteUrl: PropTypes.string.isRequired,
};

export default withConfig(['siteUrl'])(CitySchema);
